import React, { useState } from 'react';
import './App.css'; 

function WordPage() {
  const [word, setWord] = useState('');
  const [numWords, setNumWords] = useState(10);
  const [words, setWords] = useState('');

  const fetchWords = async () => {
    try {
      const response = await fetch('https://rhyme-machine-backend-test.azurewebsites.net/get-words', { // http://127.0.0.1:5000/get-words
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ word, num_words: numWords }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setWords(data.words);
    } catch (error) {
      console.error('Error fetching words:', error);
      setWords('An error occurred while fetching words. Please try again.');
    }
  };

  return (
    <div className="App">
      <div className="rhyme-container">
        <h1>Word Generator</h1>
        <div className="subtitle">lyric inspiration</div>
        <input
          type="text"
          placeholder="Enter a keyword"
          value={word}
          onChange={(e) => setWord(e.target.value)}
        />
        <input
          type="number"
          placeholder="Number of words"
          value={numWords}
          onChange={(e) => setNumWords(e.target.value)}
        />
        <button onClick={fetchWords}>Generate Output</button>
        <pre>{words}</pre>
      </div>
    </div>
  );
}

export default WordPage;